import React from "react";
import Store from "../store/Store";
import {CloseButton, Container, Nav, Navbar} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faBars, faChevronRight, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';  // Itt importáljuk a fa-xmark és fa-bars ikonokat
import {Offcanvas} from "react-bootstrap"
import {Link} from "react-router-dom";
import Api from "../api/Api";
import constants from "../constants";
import HarvestYearSelector from "./HarvestYearSelector";

import '../css/header.css';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            showYearSelector: false, // Új állapot a nézet kezelésére
        };
    }

    async doLogout() {
        await Api.logout();
        this.setState({expanded:false});
    }


    render() {
        const {isLoggedIn,harvestYears,actualHarvestYear, user} = Store.getState();
        if (isLoggedIn) {
            return (
                <Navbar expand={false} collapseOnSelect={true}>
                    <Container fluid>
                        <Link to="/" className={'navbar-brand'}><img className={"navbar-img"} src="/img/icon.png" alt="" onClick={() => this.setState({ expanded: false, showYearSelector: false })}/></Link><h3>AgRekord</h3>
                        
                        {this.state.expanded ? (
                            <button onClick={() => this.setState({ expanded: false, showYearSelector: false })} 
                                    aria-controls="offcanvasNavbar" 
                                    className="navbar-toggler close-menu">
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        ) : (
                            <Navbar.Toggle onClick={() => this.setState({expanded: true})} aria-controls="offcanvasNavbar" />
                        )}

                        
                        <Navbar.Offcanvas show={this.state.expanded}
                            id="offcanvasNavbar"
                            aria-labelledby="offcanvasNavbarLabel"
                            placement="end"
                            backdrop={false}
                        >
                            <Offcanvas.Body className="d-flex flex-column header-main-menu">
                                <Nav className="justify-content-start flex-grow-1" >
                                <Link onClick={() => this.setState({ showYearSelector: true })} className={"nav-link"} to="#">
                                        {
                                            // Ha nincs kiválasztva év, vagy csak egy elem van, akkor automatikusan az első legyen kiválasztva
                                            harvestYears && harvestYears.length > 0
                                                ? (actualHarvestYear 
                                                    ? harvestYears.find(year => year.id === actualHarvestYear)?.name
                                                    : harvestYears[0].name)  // Ha nincs kiválasztva év, az első elem legyen
                                                : "Év kiválasztása"
                                        }
                                    <FontAwesomeIcon icon={faChevronRight} /></Link>
                                    <hr className={"mt25px mb25px"}/>
                                    <Link onClick={() => this.setState({expanded:false})} className={"nav-link mb50px"} to="/">Főoldal <FontAwesomeIcon icon={faChevronRight} /></Link>
                                    <Link onClick={() => this.setState({expanded:false})} className={"nav-link mb50px"} to="/tables">Táblacsoportok <FontAwesomeIcon icon={faChevronRight} /></Link>
                                    <Link onClick={() => this.setState({expanded:false})} className={"nav-link mb50px"} to="/task">Összes feladat <FontAwesomeIcon icon={faChevronRight} /></Link>
                                    <Link onClick={() => this.setState({expanded:false})} className={"nav-link mb50px"} to="/my-task">Feladataim <FontAwesomeIcon icon={faChevronRight} /></Link>
                                    {user?.permissions?.includes('pwaCreateTask') && ( // csak ha van jogosultsága
                                        <Link onClick={() => this.setState({expanded:false})} className={"nav-link"} to="/new-task">Új feladat <FontAwesomeIcon icon={faChevronRight} /></Link>
                                    )}
                                    <hr className={"mt25px mb25px"}/>
                                    <a href='#' className={"nav-link"} onClick={() => this.doLogout()}>Kijelentkezés <FontAwesomeIcon icon={faRightFromBracket} /></a>
                                </Nav>
                                <div className="align-self-end"><p>{constants.APP_VERSION}</p></div>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                        <HarvestYearSelector
                            show={this.state.showYearSelector} 
                            onClose={() => this.setState({ showYearSelector: false })} 
                            harvestYears={harvestYears} 
                            actualHarvestYear={actualHarvestYear} 
                        />

                    </Container>
                </Navbar>
            );
        } else {
            return (
                <div className={"navbar"}>
                    <img className={"navbar-img"} style={{margin: '5px 10px'}} src="/img/icon.png" alt=""/>
                    <h3>Agrekord</h3>
                    <span style={{width: '70px'}}></span>
                </div>
            );
        }

    }
}

export default Header;